import styled from '@emotion/styled';

export const PolicyContainer = styled.div`
  padding: 16px 0;
`;

export const PolicyHeader = styled.h1``;

export const PolicyText = styled.p`
  font-size: 12px;
  margin-bottom: 0;
  white-space: pre-wrap;

  @media (min-width: 768px) {
    font-size: 16px;
  }
`;
